import { useState, useEffect } from "react";
import { toTranslit } from "../utils";
import { useBlogStore } from "../store";
import { createCategory } from "../api";
import { Button } from "./Button";

interface CategoryModalProps {
  isOpen: boolean;
  onClose: () => void;
  onCategoryAdded?: (newCategory: { slug: string; title: string }) => void;
}

export function AddCategoryModal({ isOpen, onClose, onCategoryAdded }: CategoryModalProps) {
  const { selectedBlog } = useBlogStore();
  const [title, setTitle] = useState("");
  const [slug, setSlug] = useState("");

  // Generate slug from title
  useEffect(() => {
    setSlug(toTranslit(title));
  }, [title]);

  // Check if form is valid
  const isFormValid = title.trim() !== "" && slug !== "" && selectedBlog !== "";

  if (!isOpen) return null;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!isFormValid) return;

    const newCategory = await createCategory({
      slug: slug.trim(),
      title: title.trim(),
      blog: selectedBlog
    });
    setTitle("");
    setSlug("");
    onClose();

    if (newCategory.data?.[0]) {
      onCategoryAdded?.(newCategory.data[0]);
    }
  };

  return (
    <div className='fixed inset-0 z-50 flex items-center justify-center'>
      <div
        className='absolute inset-0 bg-black/50 backdrop-blur-sm'
        onClick={onClose}
      />
      <div className='relative bg-white rounded-lg p-4 w-96 flex gap-6 flex-col shadow-xl'>
        <h2 className='text-lg font-semibold capitalize'>add new category</h2>
        <form
          onSubmit={handleSubmit}
          className='flex gap-3 flex-col'
        >
          <div className='relative pt-2'>
            <span className='text-[10px] uppercase font-semibold text-gray-500 absolute top-0 left-2 bg-white px-1'>category</span>
            <input
              type='text'
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              className='w-full px-3 py-2 border border-[#e0e0e0] rounded-md focus:outline-none focus:border-[#9d9d9d] placeholder-[#9F9F9F]'
              autoFocus
            />
          </div>
          <div className='relative pt-2'>
            <span className='text-[10px] uppercase font-semibold text-gray-500 absolute top-0 left-2 bg-white px-1'>slug</span>
            <input
              type='text'
              value={slug}
              readOnly
              placeholder='Will be generated from title'
              className='w-full px-3 py-2 border border-[#e0e0e0] rounded-md bg-gray-50 text-gray-600 text-sm focus:outline-none focus:border-[#9d9d9d] placeholder-[#9F9F9F] cursor-not-allowed'
            />
          </div>

          <Button
            type='submit'
            variant='successes'
            disabled={!isFormValid}
            className='self-end'
          >
            Save
          </Button>
        </form>
      </div>
    </div>
  );
}
